<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <prb-loading v-if="loading"></prb-loading>
      <v-layout class="target__layout text-xs-center" v-if="errorPage" style="min-height:70vh;" align-center>
        <v-flex xs12 class="pa-5 white">
          <span class="title white">
            <b>
              <v-icon style="margin-bottom:5px;margin-right:3px;">error_outline</v-icon>
              Error: Data not found</b>
            </span>
        </v-flex>
      </v-layout>
      <v-layout v-if="compound && compound2 && !loading && !errorPage" class="target__layout">
        <v-flex xs12>
          <div class="target_layout__content elevation-1">
            <v-flex xs12 class="pa-0" v-if="nameT.length && nameC.length">
              <div class="target-top__layout__summary-title">
                {{nameT}} | {{nameC}}
              </div>
            </v-flex>
            <prb-compound-top :compound="compound" :compound2="compound2"></prb-compound-top>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbLoading from '././PrbLoading';
import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';
import PrbCompoundTop from './prb-compound/prb-compound-top/PrbCompoundTop';

export default {
  metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s'
    }
  },
  computed: mapGetters([
    'termsVerified', 'loading'
  ]),
  components: {
    PrbLoading,
    PrbToolbar,
    PrbTerms,
    PrbFooter,
    PrbCompoundTop
  },
  name: 'prbsinglecompoundsynopsis',
  data() {
    return {
      errorPage: false,
      compound: null,
      compound2: null,
      nameC: '',
      nameT: '',
      titleName: ''
    }
  },
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    },
    loading: {
      get() {
        return this.$store.state.loading
      }
    }
  },
  mounted() {
    let that = this;

    let t = {id: that.$route.params.id, compound: that.$route.params.compound};

    that.$store.dispatch("SET_LOADING");

    this.$store.dispatch("GET_COMPOUND_RESULTS_BY_ID", t).then(function(res) {

      that.compound = that.$store.state.compoundResultsList;
      that.nameT =  that.$store.state.probeGeneName;

      if (!that.nameT || !that.compound) {
        that.errorPage = true
        that.$store.dispatch("UNSET_LOADING");
      } else {
        that.$store.dispatch("GET_COMPOUND2_RESULTS_BY_ID", that.$route.params.compound).then(function(res) {
          that.compound2 = that.$store.state.compound2ResultsList;

          if (that.compound2) {
            that.nameC = 'Compound: ' + that.compound2.PREFERRED_NAME;
            that.titleName = that.nameT + ' | ' + that.compound2.PREFERRED_NAME;
            that.$store.dispatch("UNSET_LOADING");
          } else {
            that.errorPage = true
            that.$store.dispatch("UNSET_LOADING");
          }
        });
      }

    });
  },
  watch: {
    '$route' (to, from) {

      let that = this;

      that.errorPage = false;

      that.$store.dispatch("SET_LOADING");

      let t = {id: that.$route.params.id, compound: that.$route.params.compound};

      this.$store.dispatch("GET_COMPOUND_RESULTS_BY_ID", t).then(function(res) {
        that.compound = that.$store.state.compoundResultsList;
        that.nameT =  that.$store.state.probeGeneName;
        if (!that.nameT || !that.compound) {
          that.errorPage = true
          that.$store.dispatch("UNSET_LOADING");
        } else {
          that.$store.dispatch("GET_COMPOUND2_RESULTS_BY_ID", that.$route.params.compound).then(function(res) {
            that.compound2 = that.$store.state.compound2ResultsList;
            if (that.compound2) {
              that.nameC = 'Compound: ' + that.compound2.PREFERRED_NAME;
              that.titleName = that.nameT + ' | ' + that.compound2.PREFERRED_NAME;
              that.$store.dispatch("UNSET_LOADING");
            } else {
              that.errorPage = true
              that.$store.dispatch("UNSET_LOADING");
            }
          });
        }
      });
    }
  }
}
</script>

<style>
.target-top__layout__summary-title{
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}
.target-probes__layout-title {
  width: 100%;
  font-size: 20px;
  padding: 10px;
  font-weight: 600;
  border-left: 5px solid #455A64;
  color: #455A64;
  background: rgba(0, 0, 0, .03);
}
.target-probes__layout__content__setting-btn{
  color: white;
  margin: 20px;
}
.target__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.target_layout__content {
  margin: 5px 10px;
  background-color: #ffffff;
  border-radius: 2px;
}
.target_layout--loading {
  width:100%;
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// PrbSingleCompoundSynopsis.vue?17e7a563